import React from 'react';
import { Link } from 'react-router-dom';

const CheckoutSteps = ({ step1, step2, step3, step4 }) => {
  return (
    <div className="flex justify-center mb-8">
      <nav className="flex items-center space-x-4">
        <div>
          {step1 ? (
            <Link
              to="/login"
              className="text-primary font-medium hover:text-primary-dark"
            >
              Sign In
            </Link>
          ) : (
            <span className="text-gray-400">Sign In</span>
          )}
        </div>

        <div className="text-gray-400">
          <i className="fas fa-chevron-right"></i>
        </div>

        <div>
          {step2 ? (
            <Link
              to="/shipping"
              className="text-primary font-medium hover:text-primary-dark"
            >
              Shipping
            </Link>
          ) : (
            <span className="text-gray-400">Shipping</span>
          )}
        </div>

        <div className="text-gray-400">
          <i className="fas fa-chevron-right"></i>
        </div>

        <div>
          {step3 ? (
            <Link
              to="/payment"
              className="text-primary font-medium hover:text-primary-dark"
            >
              Payment
            </Link>
          ) : (
            <span className="text-gray-400">Payment</span>
          )}
        </div>

        <div className="text-gray-400">
          <i className="fas fa-chevron-right"></i>
        </div>

        <div>
          {step4 ? (
            <Link
              to="/placeorder"
              className="text-primary font-medium hover:text-primary-dark"
            >
              Place Order
            </Link>
          ) : (
            <span className="text-gray-400">Place Order</span>
          )}
        </div>
      </nav>
    </div>
  );
};

export default CheckoutSteps;
